package controls

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.currentComposer
import androidx.compose.runtime.remember
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.Navigator
import org.w3c.dom.clipboard.Clipboard
import tools.randomId

external fun setupTooltip(id: String, title: String)


@Composable
fun Clipcy(valueToShow: String, valueToCopy: String = valueToShow, tooltip: String? = null) {
    val localId = remember { randomId(7) }
    Span({
        style {
            cursor("pointer")
            color(rgb(13, 110, 253))
        }
        id(localId)
        onClick {
            window.navigator.clipboard.writeText(valueToCopy)
            setupTooltip(localId, "Copied to clipboard!")
        }
    }) {
        Text(valueToShow)
    }
}

